import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Auth from '@/shared/auth';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import * as Sentry from '@sentry/browser';
import { Event } from '@sentry/types';
import * as SentryIntegrations from '@sentry/integrations';

Vue.use(ElementUI, {
  locale
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.NODE_ENV === 'production' ? 'https://b288703f48bf40b2b996252f866fa1c7@sentry.oustatic.com/19' : 'https://07ae6a60012a4fdd96be940659642887@sentry.oudev.org/47',
    beforeSend: (event: Event) =>
      Auth.getUser()
        .then(user => ({ ...event, user: user || undefined }))
        .catch(() => event),
    integrations: [new SentryIntegrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true
    })],
    environment: process.env.NODE_ENV,
    maxBreadcrumbs: 100
  });

  Vue.config.errorHandler = (err: Error, vm: Vue, info: string): void => {
    Sentry.captureException(err, {
      extra: {
        info
      }
    });
    throw err;
  };
}

// Some middleware to help us ensure the user is authenticated.
router.beforeEach(async (to, from, next) => {
  if (to.path === '/silent_renew.html') {
    await Auth.userManager.signinSilentCallback();
    return;
  }
  const isSignedIn = await Auth.check();
  if (to.path === '/callback' || to.path === '/nopermissions') {
    next();
  } else if (!isSignedIn) {
    await Auth.signIn();
    next();
  } else {
    next();
  }
});

new Vue({ // eslint-disable-line no-new
  el: '#app',
  router,
  render: h => h(App)
});
